import React, { Component } from "react";

import "component/lobby/MiniLobby/styles.scss";

class MiniLobby extends Component {
  render() {
    return (
      <div className="mini-lobby">
        <p>Page Not Found</p>
        <p>{`proper url (e.g. /{locale}/{sessionId}/games)`}</p>
        <p>
          sample: <a href="en-US/12345/games">en-US/12345/games</a>
        </p>
      </div>
    );
  }
}

export default MiniLobby;
